import { brands } from 'noddi-types';
import { useCurrentBrand } from '../stores/BrandStore/brandStore';

/** Customer-app features a brand opts out of. Gate entry points on these, never on the brand itself. */
export const useBrandCapabilities = () => {
  const { currentBrand } = useCurrentBrand();
  // Shine customers are booked by staff and are never sent recalls.
  const isShine = currentBrand === brands.shine;

  return { canCreateBooking: !isShine, showsRecalls: !isShine };
};
